import styles from "./cartIcon.module.css";

const bagPath =
  "M4 4.5H14Q16 4.5 16 6.5V15.25Q16 17.25 14 17.25H4Q2 17.25 2 15.25V6.5Q2 4.5 4 4.5Z";

const CartIconSvg = ({ filled = false, className = "", ...props }) => {
  const stroke = 0.8;

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={`${styles.icon} ${filled ? styles.filled : ""} ${className}`.trim()}
      {...props}
    >
      <path
        d="M6.25 4.5V3.5a2.75 2.75 0 0 1 5.5 0V4.5"
        className={styles.handle}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path d={bagPath} fill="white" />
      <path d={bagPath} className={styles.bagFill} />
      <path d={bagPath} className={styles.outline} strokeWidth={stroke} strokeLinejoin="round" />
      <path
        d="M6.5 10.75H11.5"
        className={styles.straightLine}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path
        d="M6.25 10Q9 13.25 11.75 10"
        className={styles.smile}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CartIconSvg;
